import { createGetAPI, createPatchAPI } from '@cuemath/rest-api';

import { BASE_URL } from '../constants/api';

const {
  useGet: useConvertClassesToCreditGet,
  invalidate: invalidateConvertClassesToCredit,
} = createGetAPI({
  getURL: studentCourseId =>
    `${BASE_URL}/student-course/${studentCourseId}/convert-classes-to-credits/`,
});

const { usePatch: useConvertClassesToCreditPatch } = createPatchAPI({
  getURL: studentCourseId =>
    `${BASE_URL}/student-course/${studentCourseId}/convert-classes-to-credits/`,
});

export {
  useConvertClassesToCreditGet,
  invalidateConvertClassesToCredit,
  useConvertClassesToCreditPatch,
};
